/* eslint-env browser */

import { css, html, LitElement } from 'lit';

import initModal from './init-modal.js';
import {
    trackEntryBtnClick,
    trackSalaryEntryBtnClick,
    trackSalaryEntryInscreen,
} from './services/tracking-service.js';

const ENTRY_HIDDEN_KEY = 'job-profile-entry-hidden-at';

class JobProfileEntryPodlet extends LitElement {
    render() {
        return html`<link
                href="https://assets.finn.no/pkg/@fabric-ds/css/v1/fabric.min.css"
                rel="stylesheet"
                type="text/css"
            />
            ${this.querySelector(
                '#job-profile-entry-podlet-template',
            ).content.cloneNode(true)}`;
    }

    firstUpdated() {
        const { renderRoot } = this;
        const { localStorage } = window;

        // ONBOARDING ENTRY
        const entryHidden =
            Number(localStorage.getItem(ENTRY_HIDDEN_KEY)) || false;

        const panel = renderRoot.querySelector(
            '.job-profile-onboarding--entry-exit-panel',
        );

        if (panel && !entryHidden) {
            panel.classList.remove('hidden');
            panel.classList.add('flex');

            renderRoot
                .querySelector('#job-profile-onboarding--cross-button__entry')
                ?.addEventListener('click', () => {
                    localStorage.setItem(
                        ENTRY_HIDDEN_KEY,
                        Date.now().toString(),
                    );
                    panel?.remove();
                });
        }

        // EXIT
        renderRoot
            .querySelector('#job-profile-onboarding--cross-button__exit')
            ?.addEventListener('click', () => {
                renderRoot
                    .querySelector('.job-profile-onboarding--entry-exit-panel')
                    ?.remove();
            });

        // ONBOARDING ENTRY LINK
        const profileEntryLink = renderRoot.querySelectorAll(
            '.job-profile-onboarding--entry-link',
        );
        Array.from(profileEntryLink).forEach((el) =>
            el.addEventListener('click', () => {
                trackEntryBtnClick(el.href, el.dataset.objectPosition);
            }),
        );

        // ACTIVE PROFILE ENTRY
        const activeProfileEntryLink = renderRoot.querySelectorAll(
            '.job-profile--nudge-link',
        );
        Array.from(activeProfileEntryLink).forEach((el) =>
            el.addEventListener('click', () => {
                const { objectName, objectPosition } = el.dataset;
                trackEntryBtnClick(
                    el.href,
                    objectPosition,
                    objectName,
                    'Job profile nudge',
                );
            }),
        );

        // SALARY ENTRY
        const salaryEntryLinks = [
            ...renderRoot.querySelectorAll('.job-salary--entry-link'),
        ];

        // Inscreen tracking
        if (salaryEntryLinks.length > 0) {
            const { activeProfile } = salaryEntryLinks[0].dataset;
            trackSalaryEntryInscreen(activeProfile === 'true');
        }

        // Click tracking
        salaryEntryLinks.forEach((el) => {
            el.addEventListener('click', () => {
                const { activeProfile } = el.dataset;
                trackSalaryEntryBtnClick(activeProfile === 'true');
            });
        });

        // LANDING PAGE MODAL GENERAL
        /**
         * The modal needs at least 1 second delay in order for scroll-doctor to work properly.
         * This is because the MFP renders ads that contain some sort of script that overrides the
         * styling that scroll-doctor sets on document.body. The delay will (in most cases where user
         * has somewhat fast internet) make scroll-doctor set it's styling _after_ the ads are rendered,
         * preventing the disappearal of scroll lock styling
         */
        setTimeout(() => {
            initModal(renderRoot);
        }, 1000);
    }

    static styles = css`
        :not(:defined) {
            visibility: hidden;
        }

        #happy-woman-svg,
        #frustrated-man-svg {
            -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
        }

        #gradient-bg {
            background: linear-gradient(
                193.73deg,
                #e3e9ee 46.86%,
                rgba(227, 233, 238, 0.2) 91.11%
            );
            clip-path: polygon(0 60%, 0% 100%, 75% 100%);
            height: 100%;
            position: absolute;
            inset: 0;
            border-radius: 0 0 8px 8px;
        }

        /* to make it possible to override tooltip with button title */
        #job-profile-landing-modal--crossoff-icon svg {
            pointer-events: none;
        }

        @media (max-width: 480px) {
            #gradient-bg {
                clip-path: polygon(0 82%, 100% 75%, 100% 100%, 0% 100%);
                border-radius: 0;
            }
        }

        .flip {
            transform: scaleX(-1);
        }
    `;
}

customElements.define('job-profile-entry-podlet', JobProfileEntryPodlet);
